// A tiny browser-only hint: this browser has signed up / in with Google. The login page shows "Continue with Google" only when it is set.
const KEY = 'sk_google_user';
export const markGoogleUser = () => { try { localStorage.setItem(KEY, '1'); } catch { /* storage blocked: the hint is only a convenience */ } };
export const hasGoogleHint = () => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } };
